import React from 'react';
import { injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import styled from 'styled-components';

import { Select } from 'common/form-controls';
import PropTypes from 'prop-types';
import { Flex, RadioButtons } from 'ui';

const StyledInputDiv = styled.div`
  width: 40%;
  margin-left: 5%;
`;

const StyledInput = styled.div`
  width: 40%;
`;

const StyledFlex = styled(Flex)`
  width: 100%;
`;

// eslint-disable-next-line no-undefined
const fieldRequired = value => value ? undefined : 'Required';

// eslint-disable-next-line
const maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;
const maxLength40 = maxLength(40);
const OrderTypeWizard = ({
  data,
  intl,
  onSelectionChange,
  renderInputMaxLen,
  renderInput,
  handleRadioChange,
}) =>
  <>
    {data.orderTypes.length > 0 &&
      <Select
        name='orderType'
        label={intl.formatMessage({ id: 'typesForm.labels.ORDER_TYPE' })}
        placeholder={intl.formatMessage({
          id: 'typesForm.placeholders.ORDER_TYPE',
        })}
        onSelectionChange={onSelectionChange}
        searchable={true}
        items={data.orderTypes}
      />
    }
    {data.descriptions.length > 0 &&
      <StyledFlex fdr jcfs>
        <Select
          name='description'
          label={intl.formatMessage({ id: 'typesForm.labels.DESCRIPTION' })}
          placeholder={intl.formatMessage({
            id: 'typesForm.placeholders.DESCRIPTION',
          })}
          onSelectionChange={onSelectionChange}
          searchable={true}
          items={data.descriptions}
        />
        {data.description && data.description.input &&
          <StyledInputDiv>
            <Field
              name='description_custom'
              description={intl.formatMessage({ id: 'typesForm.labels.CUSTOM_DESCRIPTION' })}
              max={40}
              prefix={`${data.orderType.text} - `}
              component={renderInputMaxLen}
              validate={[
                fieldRequired,
                maxLength40,
              ]}
            />
          </StyledInputDiv>
        }
      </StyledFlex>
    }
    {data.costPaidBys.length > 0 &&
      <Select
        name='paidBy'
        label={intl.formatMessage({ id: 'typesForm.labels.PAID_BY' })}
        placeholder={intl.formatMessage({
          id: 'typesForm.placeholders.PAID_BY',
        })}
        onSelectionChange={onSelectionChange}
        searchable={true}
        items={data.costPaidBys}
      />
    }
    {data.paidByValues.items.length > 0 &&
      <Select
        name={data.paidByValues.key}
        label={data.paidByValues.label}
        placeholder={intl.formatMessage(
          { id: 'typesForm.placeholders.PAID_BY_VALUE' },
          { value: data.paidByValues.key },
        )}
        onSelectionChange={onSelectionChange}
        searchable={true}
        items={data.paidByValues.items}
      />
    }
    {data.indicators.length > 0 &&
      <StyledFlex ffrn jcfs aic>
        <Select
          name='indicator'
          label={intl.formatMessage({ id: 'typesForm.labels.INDICATOR' })}
          placeholder={intl.formatMessage({
            id: 'typesForm.placeholders.INDICATOR',
          })}
          onSelectionChange={onSelectionChange}
          searchable={true}
          items={data.indicators}
        />
        {data.splitInvoice ?
          <RadioButtons
            title={intl.formatMessage({ id: 'typesForm.labels.SPLIT_INVOICE' })}
            name='splitInvoice'
            onChange={handleRadioChange}
            values={[
              {
                key: 0,
                description: intl.formatMessage({ id: 'common.NO' }),
              },
              {
                key: 1,
                description: intl.formatMessage({ id: 'common.YES' }),
              },
            ]}
          /> :
          null
        }
      </StyledFlex>
    }
    {(data?.businessSubTypes?.length > 1 ||
      (data?.businessSubTypes?.length === 1 && !data?.businessSubTypes.find(v => v.isDefault))) &&
      <Select
        name='businessSubType'
        label={intl.formatMessage({ id: 'typesForm.labels.BUSINESS_SUB_TYPE' })}
        placeholder={intl.formatMessage({
          id: 'typesForm.placeholders.BUSINESS_SUB_TYPE',
        })}
        onSelectionChange={onSelectionChange}
        searchable={true}
        required={false}
        disabled={!data?.isFiscalCodeServiceCenter}
        items={data?.businessSubTypes.map(v => ({
          id: v.additionalParameter,
          text: v.description,
        }))}
      />
    }
    {data.dynamicValue.valueKey &&
      <Select
        name={data.dynamicValue.key}
        label={data.dynamicValue.label}
        placeholder={intl.formatMessage(
          {
            id: 'typesForm.placeholders.VALUE',
          },
          { value: data.dynamicValue.label },
        )}
        onSelectionChange={onSelectionChange}
        searchable={true}
        items={data.dynamicValue.items}
      />
    }
    {data.wizardInputs.items.length > 0 &&
      data.wizardInputs.items?.map(item =>
        <StyledInput key={item.name}>
          <Field
            name={item.name}
            description={item.description}
            component={renderInput}
            validate={[fieldRequired]}
            disabled={item.readonly}
          />
        </StyledInput>,
      )}
  </>;
OrderTypeWizard.propTypes = {
  onSelectionChange: PropTypes.func,
  renderInputMaxLen: PropTypes.func,
  renderInput: PropTypes.func,
  data: PropTypes.object,
  handleRadioChange: PropTypes.func,
  intl: PropTypes.object,
};

export default injectIntl(OrderTypeWizard);
